import _ from "lodash";
import moment from "moment";
import {generateFetchFieldListAction, GET_OBJECT_SUCCESS} from "../../../../../apps/KpModule/actions/api"
import {changeFieldProperty, setFieldEdition, setFieldVisibility} from "../../../../../apps/KpModule/actions";
import {getFormValues} from "redux-form";

export const module_ = {
    name: 'ReliefFundPayment',
    tKey: 'mTitle_solicitationManagement',
    object: 'ReliefFund',
    category: {path: 'menuTitle_reliefFund', icon: 'heartHandshake'},
    newable: false,
    removable: false,
    viewMap: {
        dt: [
            {path: 'applicationNumber'},
            {path: 'organizationTradingName', tKey: 'tradingName', width: 250},
            {path: 'object', width: 250},
            {path: 'totalAwardedAmountsInEuros', tooltip: true},
            {path: 'totalProposedAmountsInEuros', tooltip: true},
            {path: 'totalValidatedAmountsInEuros', tKey: 'Dont Libéré (€)', tooltip: true},
            {path: 'totalAwardedAmountsInKilograms', tooltip: true},
            {path: 'totalProposedAmountsInKilograms', tooltip: true},
            {path: 'totalValidatedAmountsInKilograms', tKey: 'Dont Libéré (kg)', tooltip: true},
            {path: 'incompletePayments', tKey: 'Justification attendue', display: 'number', type: 'status', fieldPath: ['id', 'number', 'bStyle', 'style'], width: 250},
            //{path: 'status', type: 'status', fieldPath: ['id', 'name', 'bStyle'], translate: true}
        ],
        form: {
            fields: [
                {path: 'applicationNumber', editable: false},
                {path: 'organizationTradingName', tKey: 'tradingName', editable: false},
                {path: 'object', editable: false},
                //{path: 'totalAwardedAmount', tKey: 'awardedAmount'},
                {
                    path: 'needs',
                    hidden: true,
                    fieldPath: [
                        'id',
                        'natureOfHelp.id',
                        'name', 'nameWithUnit',
                        'landType.id', 'form.id',
                        'totalAmountInEuros', 'totalAmountInKilograms',
                        'requestedAmountInEuros', 'requestedAmountInKilograms',
                        'awardedAmountInEuros', 'awardedAmountInKilograms',
                    ],
                },
                {
                    path: 'payments',
                    tKey: 'Suivi des sollicitations',
                    type: 'accordion',
                    removable: true,
                    viewMap: {
                        dt: [
                            { path: 'need', display: 'nameWithUnit', tKey: 'type', translate: true },
                            { path: 'awardedAmountInEuros', tKey: 'awardedInEuros'},
                            { path: 'proposedAmountInEuros'},
                            { path: 'awardedAmountInKilograms'},
                            { path: 'proposedAmountInKilograms'},
                            { path: 'thirdPartyRecipient', tKey: 'tiers'},
                            { path: 'status', type: 'status', fieldPath: ['id', 'name', 'bStyle'], translate: true },
                            { path: 'paymentDate', tKey: 'Libération effectuée le'},
                            { path: 'noDeleteButtonAccess', hidden: true}
                        ],
                        form: [
                            {
                                path: 'need',
                                tKey: 'type',
                                display: 'nameWithUnit',
                                filters: ['byReliefFund', 'hasAwardedAmount',
                                    //'stillHaveSold'
                                ],
                                fieldPath: ['id', 'name', 'nameWithUnit', 'awardedAmountInEuros', 'awardedAmountInKilograms', 'natureOfHelp.unit.id', 'form.id'],
                                subscriptions: {
                                    onChange: (newValue, oldValue, { store, module }) => {
                                        const state = store.getState();
                                        const paymentsField = module.viewMap.form.fields.find(field => field.path === 'payments')

                                        const awardedAmountInEurosField = paymentsField.viewMap.form.fields.find(field => field.path === 'awardedAmountInEuros')
                                        const awardedAmountInKilogramsField = paymentsField.viewMap.form.fields.find(field => field.path === 'awardedAmountInKilograms')

                                        const balanceInEurosField = paymentsField.viewMap.form.fields.find(field => field.path === 'balanceInEuros')
                                        const balanceInKilogramsField = paymentsField.viewMap.form.fields.find(field => field.path === 'balanceInKilograms')

                                        const proposedAmountInEurosField = paymentsField.viewMap.form.fields.find(field => field.path === 'proposedAmountInEuros')
                                        const proposedAmountInKilogramsField = paymentsField.viewMap.form.fields.find(field => field.path === 'proposedAmountInKilograms')

                                        const accountField = paymentsField.viewMap.form.fields.find(field => field.path === 'account')
                                        const thirdPartyRecipientField = paymentsField.viewMap.form.fields.find(field => field.path === 'thirdPartyRecipient')

                                        if (newValue) {
                                            const payments = paymentsField.getValue()
                                            const proposedAmountInEuros = proposedAmountInEurosField.getValue()
                                            const proposedAmountInKilograms = proposedAmountInKilogramsField.getValue()
                                            const payment = getFormValues('paymentsEditObject')(state)
                                            const proposedAmountIsEditable = ['draft', 'incomplete'].includes(_.get(payment, 'status.id'))

                                            const needPaymentsInEuros = payments
                                                .filter(payment => !['refused', 'draft', 'incomplete'].includes(_.get(payment, 'status.id')) && payment.need?.id === newValue.id)
                                                .reduce((acc, payment) => {
                                                    if(!payment.proposedAmountInEuros) return acc
                                                    return acc + parseInt(payment.proposedAmountInEuros, 10)
                                                }, 0)
                                            const needPaymentsInKilograms = payments
                                                .filter(payment => !['refused', 'draft', 'incomplete'].includes(_.get(payment, 'status.id')) && payment.need?.id === newValue.id)
                                                .reduce((acc, payment) => {
                                                    if(!payment.proposedAmountInKilograms) return acc
                                                    return acc + parseInt(payment.proposedAmountInKilograms, 10)
                                                }, 0)
                                            const balanceInEuros = newValue.awardedAmountInEuros - needPaymentsInEuros
                                            const balanceInKilograms = newValue.awardedAmountInKilograms - needPaymentsInKilograms

                                            awardedAmountInEurosField.setValue(newValue.awardedAmountInEuros)
                                            awardedAmountInKilogramsField.setValue(newValue.awardedAmountInKilograms)
                                            balanceInEurosField.setValue(balanceInEuros)
                                            balanceInKilogramsField.setValue(balanceInKilograms)
                                            store.dispatch(changeFieldProperty(proposedAmountInEurosField.id, 'maxValue', newValue.awardedAmountInEuros - needPaymentsInEuros))
                                            store.dispatch(changeFieldProperty(proposedAmountInKilogramsField.id, 'maxValue', newValue.awardedAmountInKilograms - needPaymentsInKilograms))
                                            if (proposedAmountIsEditable && proposedAmountInEuros > balanceInEuros) { proposedAmountInEurosField.setValue(0)  }
                                            if (proposedAmountIsEditable && proposedAmountInKilograms > balanceInKilograms) { proposedAmountInKilogramsField.setValue(0) }
                                        }
                                        store.dispatch(setFieldVisibility(awardedAmountInEurosField.id, !!newValue && newValue.natureOfHelp.unit.id === "euro"))
                                        store.dispatch(setFieldVisibility(proposedAmountInEurosField.id, !!newValue && newValue.natureOfHelp.unit.id === "euro"))
                                        store.dispatch(setFieldVisibility(accountField.id, !!newValue && newValue.natureOfHelp.unit.id === "euro"))
                                        store.dispatch(setFieldVisibility(balanceInEurosField.id, !!newValue && newValue.natureOfHelp.unit.id === "euro"))

                                        store.dispatch(setFieldVisibility(awardedAmountInKilogramsField.id, !!newValue && newValue.natureOfHelp.unit.id === "kilogram"))
                                        store.dispatch(setFieldVisibility(proposedAmountInKilogramsField.id, !!newValue && newValue.natureOfHelp.unit.id === "kilogram"))
                                        store.dispatch(setFieldVisibility(balanceInKilogramsField.id, !!newValue && newValue.natureOfHelp.unit.id === "kilogram"))

                                        store.dispatch(setFieldVisibility(thirdPartyRecipientField.id, !!newValue && newValue.form.id === "thirdPartyDirectPayment"))
                                    }
                                }
                            },
                            { path: 'awardedAmountInEuros', tKey: 'awardedInEuros', hidden: true, disabled: true },
                            { path: 'balanceInEuros', hidden: true, tKey: 'Solde à Libérer (€)', disabled: true},
                            { path: 'proposedAmountInEuros', hidden: true, default: 0, wholePositiveNumber: true, required: true,},
                            { path: 'awardedAmountInKilograms', hidden: true, disabled: true },
                            { path: 'balanceInKilograms', hidden: true, tKey: 'Solde à Libérer (kg)', disabled: true},
                            { path: 'proposedAmountInKilograms', hidden: true, default: 0, wholePositiveNumber: true, required: true,},
                            { path: 'account', tKey: 'Compte bancaire', filters: ['isEmergencyFundBankAccount'], required: true },
                            { path: 'thirdPartyRecipient', filters: ['isSupplier', 'isEligibleForDirectAidPayment'], required: true},
                            { path: 'paymentDate', tKey: 'Libération effectuée le' , endDate: moment().format('YYYY-MM-DD')},
                            { path: 'comments', tKeyText: 'Suivi' },
                            {
                                path: 'status',
                                disabled: true,
                                fieldPath: ['id', 'name', 'bStyle'],
                                default: {id: 'draft', name: 'Brouillon', bStyle: 'default'},
                                subscriptions: {
                                    onChange: (newValue, oldValue, { store, module }) => {
                                        const state = store.getState();
                                        const payment = getFormValues('paymentsEditObject')(state)
                                        const unit = payment?.need?.natureOfHelp?.unit?.id

                                        const paymentDate = !!payment?.paymentDate

                                        store.dispatch(setFieldVisibility('e_payments.e_paymentDate', newValue && newValue.id === 'validated'))
                                        store.dispatch(setFieldVisibility('e_payments.e_balanceInEuros', unit === 'euro' && newValue && ['draft', 'incomplete'].includes(newValue.id)))
                                        store.dispatch(setFieldVisibility('e_payments.e_balanceInKilograms', unit === 'kilogram' && newValue && ['draft', 'incomplete'].includes(newValue.id)))
                                        store.dispatch(setFieldEdition('e_payments.e_need', newValue && ['draft', 'incomplete'].includes(newValue.id)))
                                        store.dispatch(setFieldEdition('e_payments.e_proposedAmountInEuros', newValue && ['draft', 'incomplete'].includes(newValue.id)))
                                        store.dispatch(setFieldEdition('e_payments.e_proposedAmountInKilograms', newValue && ['draft', 'incomplete'].includes(newValue.id)))
                                        store.dispatch(setFieldEdition('e_payments.e_account', newValue && ['draft', 'incomplete'].includes(newValue.id)))
                                        store.dispatch(setFieldEdition('e_payments.e_paymentDate', !paymentDate))
                                        const paymentsField = module.viewMap.form.fields.find(field => field.path === 'payments')
                                        const DeleteButtonAccessField = paymentsField.viewMap.form.fields.find(field => field.path === 'noDeleteButtonAccess')
                                        DeleteButtonAccessField.setValue(newValue && !['draft', 'incomplete'].includes(newValue.id))
                                    }
                                }
                            },
                            { path: 'noDeleteButtonAccess', hidden: true}
                        ]
                    }
                },
                {path: 'conversations', tKey: "interactionZone"},
                {path: 'submitter', fieldPath: ['id', 'firstname', 'lastname', 'mail'], hidden: true},
                {path: 'buttons', hidden: true}
            ]
        }
    },
    filters: [
        'userHasAuthorization',
        {
            path: 'byStatusForDecision',
            query: () => {
                return { status: 'accepted'}
            }
        }
    ],
    actionSubscriptions: [
        {
            actionType: GET_OBJECT_SUCCESS,
            subscription: ({ store }) => {
                const state = store.getState()
                const reliefFund = _.pick(state.edit.object.data, ['id'])

                store.dispatch(generateFetchFieldListAction(
                    'm-C-reliefFundPayment.Payment_need',
                    store.getState,
                    {
                        data: {reliefFund}
                    }
                ))
            }
        }
    ]
}
